import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaCapacitaciones from './TablaCapacitaciones';

const Capacitaciones: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaCapacitaciones />
    </Box>
  );
};

export default Capacitaciones;
